import sortBy from 'lodash/sortBy';

import { ASSESSMENT, LESSON } from 'global/constants';
import {
  Materials,
  LessonMaterialData,
  MaterialsData,
} from './lesson-materials.constants';
import { hasRichtextContent } from 'lib/form/richtextarea/richtextarea.utils';
import { LessonMaterialFragment } from 'approot/shared/lesson-materials/__generated__/LessonMaterialFragment';

export function getLessonMaterialsPreview(
  materialData: LessonMaterialData[],
  options: { isIntegrated: boolean }
) {
  const materialGroups: Materials[] = [];
  const sorted = sortBy(
    materialData,
    options.isIntegrated ? 'integratedSort' : 'sort'
  );

  sorted.forEach(item => {
    // hide old materials if there are published assessment activities
    if (item.type === ASSESSMENT) return;

    if (item.activitiesMaterials?.length) {
      const filteredMaterials =
        (item.activitiesMaterials
          .flatMap(n => n.lessonMaterials)
          .filter(m => m && !!m.name.trim()) as LessonMaterialFragment[]) || [];

      materialGroups.push({
        id: item.id,
        itemNumber:
          sorted
            .filter(i => i.type === LESSON)
            .findIndex(i => i.id === item.id) + 1,
        type: item.type,
        activitiesMaterials: filteredMaterials,
      });
    } else if (item.materials && item.materials.length > 0) {
      const collectedMaterials = item.materials
        .filter(material => hasRichtextContent(material.data.richtext))
        .map(material => material.data.richtext);
      if (collectedMaterials.length > 0) {
        materialGroups.push({
          id: item.id,
          itemNumber:
            sorted
              .filter(i => i.type === LESSON)
              .findIndex(i => i.id === item.id) + 1,
          type: item.type,
          materials: collectedMaterials,
        });
      }
    }
  });

  return { materials: materialGroups };
}

export function getMaterialLabel(item: Materials) {
  const isLesson = item.type === LESSON;
  const typeLabel = isLesson ? 'Lesson' : 'Assessment';
  const typePosition = isLesson ? item.itemNumber : '';
  return `${typeLabel} ${typePosition}`;
}

export function hasLessonMaterials(material: MaterialsData) {
  return material.materials?.some(mat => hasRichtextContent(mat.data.richtext));
}
